import * as actions from '../utils/Constants';
import { apiPost, apiGet, apiDeleteWithBodyAndThen, apiRequest, Methods } from '../utils/Api';

const apiProgram = `${process.env.REACT_APP_API_HOST}api/program/`;
const apiPrograms = `${process.env.REACT_APP_API_HOST}api/programs`;
const apiToggleGetProgramsByPersonId = `${process.env.REACT_APP_API_HOST}api/programsByPersonId`;

export const newProgram = () => ({ type: actions.NEW_PROGRAM })

export const getPrograms = () => dispatch =>
    dispatch({
        type: actions.GET_PROGRAMS,
        payload: apiRequest(apiPrograms, Methods.Post, null, null, dispatch)
    });


export const getProgram = (id) => {
    return dispatch => {
        dispatch({
            type: actions.GET_PROGRAM,
            payload: apiRequest(apiProgram + id, Methods.get, null, dispatch)
        });
    }
}

export const getProgramsByType = (type) => ({
    type: actions.GET_PROGRAMS,
    payload: apiGet(apiPrograms + type)
});

export const setLocation = (trainingId) => ({
    type: actions.SET_LOCATION,
    payload: trainingId
})

export const deletePrograms = (ids, showMyCases, personId) => ({
    type: actions.DELETE_PROGRAM,
    payload: showMyCases
        ? apiDeleteWithBodyAndThen(apiPrograms, ids, () => apiRequest(`${apiToggleGetProgramsByPersonId}?personId=${personId}`))
        : apiDeleteWithBodyAndThen(apiPrograms, ids, () => apiGet(apiPrograms))
});

export const getProgramPickList = () => dispatch =>
    dispatch({
        type: actions.GET_PROGRAM_PICKLIST,
        payload: apiRequest(`${process.env.REACT_APP_API_HOST}api/program/picklist`, Methods.get, null, dispatch)
    });

export const toggleGetProgramsByPersonId = (personId) => {
    return dispatch => dispatch({
        type: actions.GET_PROGRAMS,
        payload: apiRequest(`${apiToggleGetProgramsByPersonId}?personId=${personId}`, Methods.get, null, dispatch)
    });
};